<template>
  <WheelSlider
    :list="[
      { perspective: 'center', items: weights, ref: 'weights', selectedIndex: (defaultWeight - minWeight) / 5 },
    ]"
    @on-change="handleChange"
  />
</template>

<script>
import WheelSlider from '@/components/base/WheelSlider'

export default {
  name: 'Weight',
  components: { WheelSlider },
  props: {
    minWeight: {
      type: Number,
      default: 50,
    },
    maxWeight: {
      type: Number,
      default: 1000,
    },
    value: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      weights: Array.from({
        length: Math.floor((this.maxWeight - this.minWeight) / 5) + 1
      }, (_, i) => 
        ({ label: `${this.minWeight + i * 5} lbs`, value: this.minWeight + i * 5 })
      ),
    }
  },
  computed: {
    defaultWeight() {
      return this?.value || 150
    },
  },
  methods: {
    handleChange(newWeight) {
      console.log('newWeight', newWeight)
      this.$emit('input', newWeight.selectedValue?.value || 110)
    },
  },
}
</script>